import * as z from 'zod';
import { REQUIRED_IDENTIFIER_TYPES } from 'src/features/gateway/utils/types';
import { validationMessagesMap } from 'src/utils/messages';
import { VISITOR_CATEGORY_TYPE } from 'src/features/zone/utils/types';

export type GatewayFormSchemaValues = z.infer<typeof gatewayFormSchema>;
export const gatewayFormSchema = z
    .object({
        translations: z
            .array(
                z.object({
                    language: z.string(),
                    name: z.string().min(1),
                    description: z.string().or(z.null()),
                }),
            )
            .min(1),
        required_identifier_types: z.array(z.enum(REQUIRED_IDENTIFIER_TYPES)).min(1),
        allow_unknown_main_identifier: z.boolean(),
        require_all_identifier: z.boolean(),
        entry_zone: z.string().optional().nullable(),
        exit_zone: z.string().optional().nullable(),
        visitor_categories: z.array(z.enum(VISITOR_CATEGORY_TYPE)).optional().nullable(),
    })
    .superRefine((data, ctx) => {
        if (data.entry_zone && !data.exit_zone) return;
        if (!data.entry_zone && data.exit_zone) return;

        if (!data.entry_zone && !data.exit_zone) {
            ctx.addIssue({
                path: ['exit_zone'],
                message: validationMessagesMap.validationErrorGatewayExitEntryPoint,
                code: 'custom',
            });
            ctx.addIssue({
                path: ['entry_zone'],
                message: validationMessagesMap.validationErrorGatewayExitEntryPoint,
                code: 'custom',
            });
        }
    });
